import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Ticket, Gift, Target, Wallet } from 'lucide-react';
import { RedeemCouponCard } from '@/components/promo/RedeemCouponCard.js';
import { BonusSectionHeader } from '@/components/promo/BonusSectionHeader.js';
import { HowItWorksModal, type HowItWorksStep } from '@/components/promo/HowItWorksModal.js';
import { useMoneyCurrency } from '@/components/money/MoneyProvider.js';

export function RedeemSection() {
  const { t } = useTranslation('promo');
  const [showTutorial, setShowTutorial] = useState(false);
  const currency = useMoneyCurrency();

  const steps: HowItWorksStep[] = [Ticket, Gift, Target, Wallet].map((icon, i) => ({
    icon,
    title: t(`redeem.tutorial.step${i + 1}.title`),
    body: t(`redeem.tutorial.step${i + 1}.body`),
  }));

  return (
    <div className="flex flex-col gap-5">
      <BonusSectionHeader
        title={t('redeem.pageTitle')}
        subtitle={t('redeem.pageSubtitle')}
        onHowTo={() => setShowTutorial(true)}
        historyTab="redeem"
      />

      <RedeemCouponCard currency={currency} />

      <HowItWorksModal open={showTutorial} onClose={() => setShowTutorial(false)} steps={steps} />
    </div>
  );
}
